import React from 'react'
import { HeadingWithParagraphs } from '../Common/HeadingWithParagraph/HeadingWithParagraphs'
import { WeddingBudgetBenefitsContentProps } from '@/lib/content/weddingBudgetContent/weddingBudgetBenefitsContent'


export const BudgetWeddingBenifits = ({
    content,
}: {
    content : WeddingBudgetBenefitsContentProps
}) => {

    return (
        <div className="relative w-full  bg-secondary " >
            <div className="p-5 pt-11 pb-16 desktop-padding relative z-10" >
                <h2 className="h2 text-center " >{content.h1}</h2>
                <p className="mt-[24px] body-reg " >{content.para1}</p>
                <div>
                    {content.benifitsData.map((content, index) => (
                        <HeadingWithParagraphs content={content} />
                    ))}
                </div>

            </div>
        </div>

    )

}